"use client";

import { useLanguage } from "@/contexts/LanguageContext";

export default function SectionTechStack() {
  const { t } = useLanguage();

  const categories = [
    {
      title: t("sectionTechStack.categories.0.title"),
      desc: t("sectionTechStack.categories.0.desc"),
      tech: ["Terraform", "Pulumi", "Ansible"],
    },
    {
      title: t("sectionTechStack.categories.1.title"),
      desc: t("sectionTechStack.categories.1.desc"),
      tech: ["HashiCorp Vault", "Cloud Identity"],
    },
    {
      title: t("sectionTechStack.categories.2.title"),
      desc: t("sectionTechStack.categories.2.desc"),
      tech: ["Kubernetes", "ArgoCD"],
    },
    {
      title: t("sectionTechStack.categories.3.title"),
      desc: t("sectionTechStack.categories.3.desc"),
      tech: ["Grafana", "Datadog", "OpenTelemetry"],
    },
    {
      title: t("sectionTechStack.categories.4.title"),
      desc: t("sectionTechStack.categories.4.desc"),
      tech: ["AWS", "GCP", "Azure"],
    },
    {
      title: t("sectionTechStack.categories.5.title"),
      desc: t("sectionTechStack.categories.5.desc"),
      tech: ["GitHub Actions", "GitLab CI"],
    },
  ];

  return (
    <section className="bg-surface py-32 px-6 md:px-12 text-text-primary relative overflow-hidden border-t border-border-default">
      {/* Background Gradient */}
      <div className="absolute top-0 left-0 w-full h-[500px] bg-gradient-to-b from-brand-primary/10 to-transparent pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-20 space-y-6">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-secondary/10 text-brand-secondary text-sm font-mono tracking-wider mb-4 border border-brand-secondary/20">
            {t("sectionTechStack.badge")}
          </span>
          <h2 className="text-4xl md:text-6xl font-bold tracking-tight">
            {t("sectionTechStack.title")} <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-text-primary to-text-secondary">
              {t("sectionTechStack.titleHighlight")}
            </span>
          </h2>
          <p className="text-text-secondary text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
            {t("sectionTechStack.subtitle.before")}{" "}
            <span className="text-text-primary font-bold">
              {t("sectionTechStack.subtitle.emphasis")}
            </span>
            {t("sectionTechStack.subtitle.after")}
          </p>
        </div>

        {/* Tech Categories Grid - Updated layout for 'Stack of Winners' */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-24">
          {categories.map((item) => (
            <div
              key={item.title}
              className="bg-border-default p-8 rounded-2xl border border-border-hover hover:border-brand-primary/50 transition-colors group"
            >
              <h3 className="text-2xl font-bold mb-3 group-hover:text-brand-secondary transition-colors">
                {item.title}
              </h3>
              <p className="text-text-secondary text-sm mb-6 leading-relaxed">
                {item.desc}
              </p>
              <div className="flex flex-wrap gap-2">
                {item.tech.map((techName) => (
                  <span
                    key={techName}
                    className="text-xs font-mono bg-surface-card px-3 py-1.5 rounded text-text-secondary border border-border-default"
                  >
                    {techName}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
